/**
 * 引数文字列を半角に変換する
 * @param str
 * @returns 半角に変換された文字列
 */
const toHalfWidth = (str: string) => {
  return str.replace(/[０-９．ー]/g, s => {
    switch (s) {
      case '．':
        return '.';
      case 'ー':
        return '-';
      default:
        return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    }
  });
};

/**
 * 半角文字列のうち、数字、ハイフン、小数点でないものは除外する
 * @param str 半角文字列
 * @returns 数字、ハイフン、小数点のみの半角文字列
 */
const removeNonNumeric = (str: string) => {
  str = str.replace(/[^0-9.-]/g, '');
  return str === '' ? '0' : str;
};

/**
 * 先頭の連続する0を削除する。
 * ただし、0のみの時は0と表示
 * また、0.~という形の時、先頭の0は削除しない
 * @param str 半角文字列
 * @returns 先頭の連続する0が削除された半角文字列
 */
const removeLeadingZeros = (str: string) => {
  return str.replace(/^0+(?!\.)/, '') || '0';
};

/**
 * 引数の数字を指定された範囲の数字でカットする。
 * @param value 数字
 * @param min 範囲の最小値
 * @param max 範囲の最大値
 * @returns カットされた数字
 */
const constrainValue = (value: number, min: number, max: number) => {
  return value < min ? min : value > max ? max : value;
};

/**
 * 引数の数値文字列が、正しい数値表現になっているか確かめる
 * @param str 数値文字列
 * @returns 正しい数値表現かどうか
 */
const isValidNumber = (str: string): boolean => {
  return /^-?\d+(\.\d+)?$/.test(str);
};

/**
 * 全角数字の文字列を、指定された範囲内の半角の数字に変換する。
 * 数字とハイフン以外のものは除外する。
 *
 * @param str 入力された文字列
 * @param min 入力可能な最小の数字
 * @param max 入力可能な最大の数字
 * @returns 変換された文字列
 */
export const convertToHalfWidthNumeric = (
  str: string,
  min: number,
  max: number
) => {
  str = toHalfWidth(str);
  str = removeNonNumeric(str);
  str = removeLeadingZeros(str);

  if (!isValidNumber(str)) {
    return '0';
  }

  return constrainValue(parseFloat(str), min, max).toString();
};
